import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'shared/util/debounce';

import type { ApiActionStatus, HotelOffer, PaleState, ThunkDispatchFunc } from '@/interfaces';
import { fetchHotelResultsToAppend } from '@/state/hotelResultActions';

type UseHotelResultsReturn = {
    offers: HotelOffer[];
    status: ApiActionStatus;
    offersLeft: number;
    fetchMoreOffers: () => void;
};

export const useHotelResults = (): UseHotelResultsReturn => {
    const dispatch = useDispatch<ThunkDispatchFunc>();

    const { offers, status, numberOfOffers, currentPage, totalPages } = useSelector((state: PaleState) => state.hotelResults);

    const offersLeft = Math.max(0, numberOfOffers - offers.length);

    const fetchMoreOffers = useMemo(
        () =>
            debounce(() => {
                const next = currentPage + 1;

                if (next <= totalPages) {
                    dispatch(fetchHotelResultsToAppend({ page: String(next) }));
                }
            }, 200),
        [currentPage, totalPages, dispatch],
    );

    return {
        offers,
        status,
        offersLeft,
        fetchMoreOffers,
    };
};
